/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

/**
 * jquery.mask.js
 * @version: v1.14.15
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function() {
                var oldVal = el.data('mask-previus-value') || '',
                    newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret();

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition());
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));

(function ($) {
    "use strict";
    $(document).ready(function () {
        let request;
        let searchForm = $(".betterdocs-searchform");
        let searchField = $(".betterdocs-search-field");
        let searchCategory = $(".betterdocs-search-category");
        let popularSearch = $(".betterdocs-popular-search-keyword .popular-keyword");

        /**
         * Store search data to sessionStorage
         */
        /*sessionStorage.setItem("betterdocs_search_data", betterdocspublic.search_keyword);
        sessionStorage.setItem("search_not_found", betterdocspublic.search_not_found);*/

        // disable from submit on enter
        popularSearch.on("click", function (e) {
            e.preventDefault();
            let popularKeyword = $(this).text();
            $(this).parent('.betterdocs-popular-search-keyword').siblings('.betterdocs-searchform').find('.betterdocs-search-field').val(popularKeyword).trigger('propertychange');
        });

        searchForm.on("keyup keypress", function (e) {
            searchForm.each(function () {
                let keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
        });

        // ajax load titles on keyup to searchbox
        searchField.on("input propertychange paste", function (e) {
            searchField.each(function () {
                let thisEvent = $(this);
                let inputVal = $(this).val();
                let inputCat = thisEvent.parent('.betterdocs-searchform-input-wrap').siblings('.betterdocs-search-category').find(':selected').val();
                let resultWrapper = thisEvent.parent().parent(".betterdocs-searchform");
                let kbSlug = thisEvent.parent().parent('.betterdocs-searchform').find('.betterdocs-search-kbslug').val();

                //Before the result is fetched, we have to remove the search result wrapper based on letter limit characters
                if (!inputVal.length) {
                    var nodeResults = thisEvent.parents(".betterdocs-live-search").find(".betterdocs-search-result-wrap");
                    if (nodeResults.length > 0) {
                        nodeResults.each(function (item) {
                            $(nodeResults[item]).remove();
                        });
                    }
                }

                liveSearchAction(e, thisEvent, inputVal, inputCat, resultWrapper, kbSlug);
            });
        });

        $('.betterdocs-searchform .betterdocs-search-category').on("change", function (e) {
            let thisEvent = $(this);
            let inputVal = thisEvent.siblings('.betterdocs-searchform-input-wrap').children('.betterdocs-search-field').val();
            let inputCat = $(this).find(':selected').val();
            let resultWrapper = thisEvent.parent(".betterdocs-searchform");
            let kbSlug = thisEvent.parent('.betterdocs-searchform').find('.betterdocs-search-kbslug').val();
            liveSearchAction(e, thisEvent, inputVal, inputCat, resultWrapper, kbSlug);
        });

        function liveSearchAction(e, thisEvent, inputVal, inputCat, resultWrapper, kbSlug) {
            let resultList = thisEvent.parent(".betterdocs-searchform").find(".betterdocs-search-result-wrap");
            let searchLoader = thisEvent.parent().find(".docs-search-loader");
            let searchClose = thisEvent.parent().find(".docs-search-close");
            let search_letter_limit = betterdocspublic.search_letter_limit;
            if (
                e.key != "a" &&
                e.keyCode != 17 &&
                e.keyCode != 91 &&
                inputVal.length >= search_letter_limit
            ) {
                delay(function () {
                    ajaxLoad(
                        inputVal,
                        inputCat,
                        kbSlug,
                        resultWrapper,
                        resultList,
                        searchLoader,
                        searchClose,
                        thisEvent
                    );
                }, 400);
            } else if (!inputVal.length) {
                thisEvent.parent().parent(".betterdocs-live-search").find(".betterdocs-search-result-wrap").addClass("hideArrow");
                thisEvent.parent().parent(".betterdocs-live-search").find(".docs-search-result").slideUp(300);
                searchLoader.hide();
                searchClose.hide();
            }
        }

        $(".docs-search-close").on("click", function () {
            $(this).hide();
            $(".betterdocs-live-search .betterdocs-search-result-wrap").addClass(
                "hideArrow"
            );
            $(".betterdocs-live-search .docs-search-result").slideUp(300);
            searchField.val("");
        });

        var delay = (function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();

        function ajaxLoad(
            inputVal,
            inputCat,
            kbSlug,
            resultWrapper,
            resultList,
            searchLoader,
            searchClose,
            inputEvent
        ) {
            if (request) {
                request.abort();
            }
            request = $.ajax({
                url: betterdocspublic.ajax_url,
                type: "post",
                data: {
                    action: "betterdocs_get_search_result",
                    search_input: inputVal,
                    search_cat: inputCat,
                    kb_slug: kbSlug
                },
                beforeSend: function () {
                    searchLoader.show();
                    searchClose.hide();
                    resultList.addClass("hideArrow");
                    $(".betterdocs-live-search .docs-search-result").slideUp(400);
                },
                success: function (response) {
                    resultList.remove();
                    searchLoader.hide();
                    searchClose.show();

                    let search_letter_limit = betterdocspublic.search_letter_limit;
                    var inputVal2 = inputEvent.val();

                    //After the result is fetched, we have to remove the search result wrapper
                    if (inputVal2.length < search_letter_limit) {
                        var nodeResults = $(".betterdocs-live-search").find(".betterdocs-search-result-wrap");
                        if (nodeResults.length > 0) {
                            nodeResults.each(function (item) {
                                $(nodeResults[item]).slideUp(400);
                            });
                        }
                        searchClose.hide();
                        return;
                    }

                    resultWrapper.append(response.data.post_lists);
                }
            });
        }

        var betterdocsToc = $(".betterdocs-toc");
        var betterdocsSidebar = $("#betterdocs-sidebar");
        if (betterdocsToc.length && betterdocsSidebar.length) {
            // create an instance of TOC
            var stickyTocContent = $(".betterdocs-toc").clone();
            $(".sticky-toc-container").append(stickyTocContent);

            // make sticky toc when sidebar-content scroll ends
            $(window).on("scroll", function () {
                var stickyToc = $(".sticky-toc-container");
                var tocHeight = $(".betterdocs-sidebar-content").outerHeight();
                var tocSidebar = document.querySelector(".betterdocs-sidebar-content");
                var tocSidebarRect = tocSidebar.getBoundingClientRect();
                var tocSidebarTop = Math.abs(tocSidebarRect.top);

                if (tocSidebarRect.top < 0 && tocHeight <= tocSidebarTop) {
                    stickyToc.addClass("toc-sticky");
                } else {
                    stickyToc.removeClass("toc-sticky");
                }
                if (
                    $(window).scrollTop() >=
                    betterdocsSidebar.offset().top +
                    betterdocsSidebar.outerHeight() -
                    window.innerHeight &&
                    !betterdocsSidebar.hasClass("betterdocs-el-single-sidebar")
                ) {
                    stickyToc.removeClass("toc-sticky");
                }
            });
        }

        // Add smooth scrolling to links
        $(document).on("scroll", onScroll);
        // alert(betterdocspublic.sticky_toc_offset);
        var toc_links = $(".betterdocs-toc .toc-list a");
        toc_links.on("click", function (e) {
            e.preventDefault();
            $(document).off("scroll");
            toc_links.each(function () {
                $(this).removeClass("active");
            });
            $(this).addClass("active");
            var target = this.hash,
                $target = $(target);
            var scrollTopOffset = $target.offset().top;
            $("html, body")
                .stop()
                .animate(
                    { scrollTop: scrollTopOffset - betterdocspublic.sticky_toc_offset },
                    "slow",
                    function () {
                        $(document).on("scroll", onScroll);
                    }
                );
        });

        // function to add link active class on scroll
        function onScroll() {
            var scrollPos = $(document).scrollTop();
            $(
                ".sticky-toc-container .betterdocs-toc .toc-list a,.betterdocs-full-sidebar-right .betterdocs-toc .toc-list a"
            ).each(function () {
                var currLink = $(this);
                var refElement = $(currLink.attr("href"));
                if (
                    refElement.position().top <= scrollPos &&
                    refElement.position().top + refElement.height() > scrollPos
                ) {
                    $(".betterdocs-toc .toc-list a").removeClass("active");
                    currLink.addClass("active");
                }
            });
        }

        // close sticky toc
        $(".close-toc").on("click", function (event) {
            event.preventDefault();
            $(".sticky-toc-container").remove(".sticky-toc-container");
        });

        // close sticky toc
        $("body").on("click", ".betterdocs-print-btn", function (event) {
            let entryTitle = "";
            if ($("#betterdocs-entry-title").length) {
                entryTitle = document.getElementById("betterdocs-entry-title")
                    .innerHTML;
            }

            var printContents = document.getElementById("betterdocs-single-content")
                .innerHTML;
            var combined = document.createElement("div");
            combined.innerHTML = "<h1>" + entryTitle + "</h1>" + " " + printContents;
            combined.id = "new-doc-print";
            var pwidth = document.getElementById("betterdocs-single-content")
                .offsetWidth;
            var wheight = $(window).height();
            var winPrint = window.open(
                "",
                "",
                "left=50%,top=10%,width=" +
                pwidth +
                ",height=" +
                wheight +
                ",toolbar=0,scrollbars=0,status=0"
            );
            winPrint.document.write(combined.outerHTML);
            winPrint.document.close();
            winPrint.focus();
            winPrint.print();
            winPrint.close();
        });

        // Add accordion to sidebar category grid
        var sidebarContent = $(".betterdocs-sidebar-content");
        var catList = $(
            ".betterdocs-sidebar-content .docs-single-cat-wrap .docs-item-container"
        );
        var currentCatList = $(
            ".betterdocs-sidebar-content .docs-single-cat-wrap.current-category .docs-item-container"
        );
        var catHeading = $(
            ".betterdocs-sidebar-content .docs-single-cat-wrap .docs-cat-title-wrap"
        );

        var active_subcategory = $('.docs-sub-cat.current-sub-cat');

        catList.hide();

        if (currentCatList.length) {
            currentCatList.show().addClass("show");
        }

        /**
         * This code toggles the nested subcat arrow to down direction if it is activated, this approach is from bottom to top
         */
        if (active_subcategory.length) {
            var subcat = $(active_subcategory);
            while (subcat.attr('class') === 'docs-sub-cat' || subcat.attr('class') === 'docs-sub-cat current-sub-cat') {
                subcat.prev().children('.toggle-arrow').toggle();
                subcat.parent().css('display', 'block');
                subcat = subcat.parent();
            }
        }

        catHeading.click(function (e) {
            var $this = $(this);
            sidebarContent.find(".active-title").removeClass("active-title");
            $this.toggleClass("active-title");
            if ($this.next(catList).hasClass("show")) {
                $this
                    .next(catList)
                    .slideUp()
                    .removeClass("show");
            } else if (catList.hasClass("show")) {
                catList.slideUp().removeClass("show");
                $this
                    .next(catList)
                    .slideToggle()
                    .toggleClass("show");
            } else {
                $this
                    .next(catList)
                    .slideToggle()
                    .toggleClass("show");
            }
        });

        var docSubCat = $(".docs-sub-cat-title, .el-betterdocs-grid-sub-cat-title");
        docSubCat.each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                $(this)
                    .children(".toggle-arrow")
                    .toggle();
                $(this)
                    .next(".docs-sub-cat, .docs-sub-cat-list")
                    .slideToggle();
            });
        });

        var docTocTitle = $(".betterdocs-toc.collapsible-sm .toc-title");
        docTocTitle.each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                $(this)
                    .children(".angle-icon")
                    .toggle();
                $(this)
                    .next(".toc-list")
                    .slideToggle();
            });
        });

        // single post feedback form modal
        var formModal = $("#betterdocs-form-modal");
        var formModalContent = $("#betterdocs-form-modal .modal-content");

        //select all the a tag with name equal to modal
        $("a[name=betterdocs-form-modal]").click(function (e) {
            e.preventDefault();
            formModal.fadeIn(500);
        });

        //if outside of modal content is clicked
        $(document).mouseup(function (e) {
            if (
                !formModalContent.is(e.target) &&
                formModalContent.has(e.target).length === 0
            ) {
                formModal.fadeOut();
            }
        });

        //if close button is clicked
        $(".betterdocs-modalwindow .close").click(function (e) {
            e.preventDefault();
            formModal.fadeOut(500);
        });

        // ajax feedback form submit
        var feedbackForm = $("#betterdocs-feedback-form");

        var feedbackFormFields = $(
            "#betterdocs-feedback-form input, #betterdocs-feedback-form textarea"
        );
        feedbackFormFields.on("keyup", function () {
            $(this).removeClass("val-error");
            $(this)
                .siblings(".error-message")
                .remove();
        });
        feedbackForm.on("submit", function (e) {
            e.preventDefault();
            var form = $(this);
            var message_name = $("#message_name");
            var message_email = $("#message_email");
            var message_subject = $("#message_subject");
            var message_text = $("#message_text");
            betterdocsFeedbackFormSubmit(
                form,
                message_name,
                message_email,
                message_subject,
                message_text
            );
        });
        function betterdocsFeedbackFormSubmit(
            form,
            message_name,
            message_email,
            message_subject,
            message_text
        ) {
            if (request) {
                request.abort();
            }
            request = $.ajax({
                url: betterdocspublic.ajax_url,
                type: "post",
                data: {
                    action: "betterdocs_feedback_form_submit",
                    form: form.serializeArray(),
                    postID: betterdocspublic.post_id,
                    message_name: message_name.val(),
                    message_email: message_email.val(),
                    message_subject: message_subject.val(),
                    message_text: message_text.val(),
                    security: betterdocspublic.nonce,
                },
                beforeSend: function () { },
                success: function (data) {
                    var data = JSON.parse(data);
                    if (data.sentStatus) {
                        if (data.sentStatus === "success") {
                            $(".response").html(
                                '<span class="success-message">' + data.sentMessage + "</span>"
                            );
                            form[0].reset();
                            delay(function () {
                                $(".betterdocs-modalwindow").fadeOut(500);
                                $(".response .success-message").remove();
                            }, 3000);
                        } else {
                            $(".response").html(
                                '<span class="error-message">' + data.sentMessage + "</span>"
                            );
                        }
                    } else {
                        if (data.nameStatus === "error") {
                            if (message_name.hasClass("val-error") == false) {
                                message_name.addClass("val-error");
                                $(".form-name").append(
                                    '<span class="error-message">' + data.nameMessage + "</span>"
                                );
                            }
                        }
                        if (data.emailStatus === "error") {
                            if (message_email.hasClass("val-error") == false) {
                                message_email.addClass("val-error");
                                $(".form-email").append(
                                    '<span class="error-message">' + data.emailMessage + "</span>"
                                );
                            }
                        }
                        if (data.messageStatus === "error") {
                            if (message_text.hasClass("val-error") == false) {
                                message_text.addClass("val-error");
                                $(".form-message").append(
                                    '<span class="error-message">' +
                                    data.messageMessage +
                                    "</span>"
                                );
                            }
                        }
                    }
                }
            });
        }

        if ($(".batterdocs-anchor").length) {
            // tooltips
            $(".batterdocs-anchor")
                .hover(
                    function () {
                        var title = $(this).attr("data-title");
                        $("<div/>", {
                            text: title,
                            class: "tooltip-box"
                        }).appendTo(this);
                    },
                    function () {
                        // $(document).find("div.tooltip-box").remove();
                    }
                )
                .on("click", function (e) {
                    // Clipboard
                    e.preventDefault();
                    var a = new ClipboardJS(".batterdocs-anchor");
                    a.on("success", function (e) {
                        $(document)
                            .find("div.tooltip-box")
                            .text(betterdocspublic.copy_text);
                        e.clearSelection(),
                            $(e.trigger).addClass("copied"),
                            setTimeout(function () {
                                $(e.trigger).removeClass("copied");
                            }, 2000);
                    });
                });

            (function () {
                if (typeof self === "undefined" || !self.Prism || !self.document) {
                    return;
                }

                if (!Prism.plugins.toolbar) {
                    console.warn(
                        "Copy to Clipboard plugin loaded before Toolbar plugin."
                    );

                    return;
                }

                var ClipboardJS = window.ClipboardJS || undefined;

                if (!ClipboardJS && typeof require === "function") {
                    ClipboardJS = require("clipboard");
                }

                var callbacks = [];

                if (!ClipboardJS) {
                    var script = document.createElement("script");
                    var head = document.querySelector("head");

                    script.onload = function () {
                        ClipboardJS = window.ClipboardJS;

                        if (ClipboardJS) {
                            while (callbacks.length) {
                                callbacks.pop()();
                            }
                        }
                    };

                    script.src =
                        "https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/2.0.0/clipboard.min.js";
                    head.appendChild(script);
                }

                Prism.plugins.toolbar.registerButton("copy-to-clipboard", function (
                    env
                ) {
                    var linkCopy = document.createElement("button");
                    linkCopy.textContent = "Copy";

                    if (!ClipboardJS) {
                        callbacks.push(registerClipboard);
                    } else {
                        registerClipboard();
                    }

                    return linkCopy;

                    function registerClipboard() {
                        var clip = new ClipboardJS(linkCopy, {
                            text: function () {
                                return env.code;
                            }
                        });

                        clip.on("success", function () {
                            linkCopy.textContent = "Copied!";

                            resetText();
                        });
                        clip.on("error", function () {
                            linkCopy.textContent = "Press Ctrl+C to copy";

                            resetText();
                        });
                    }

                    function resetText() {
                        setTimeout(function () {
                            linkCopy.textContent = "Copy";
                        }, 5000);
                    }
                });
            })();
        }

        //FAQ LOGIC
        $('.betterdocs-faq-post').on('click', function (e) {
            var current_node = $(this);
            var active_list = $('.betterdocs-faq-group.active');

            if (!current_node.parent().hasClass('active')) {
                current_node.parent().addClass('active');
                current_node.children('svg').toggle();
                current_node.next().slideDown();
            }

            for (let node of active_list) {
                if ($(node).hasClass('active')) {
                    $(node).removeClass('active');
                    $(node).children('.betterdocs-faq-post').children('svg').toggle();
                    $(node).children('.betterdocs-faq-main-content').slideUp();
                }
            }
        });

        //FAQ LOGIC 2 

        $('.betterdocs-faq-post-layout-2').on('click', function (e) {
            var current_node = $(this);

            if (!current_node.parent().hasClass('active')) {
                current_node.parent().addClass('active');
                current_node.children('.betterdocs-faq-post-layout-2-icon-group').children('svg').toggle();
                current_node.next().slideDown();
            } else {
                current_node.parent().removeClass('active');
                current_node.children('.betterdocs-faq-post-layout-2-icon-group').children('svg').toggle();
                current_node.next().slideUp();
            }

        });

        $('.betterdocs-feelings').on('click', function (e) {
            e.preventDefault();

            var feelings = e.currentTarget.dataset.feelings;
            if (betterdocspublic != undefined &&
                betterdocspublic.FEEDBACK != undefined &&
                betterdocspublic.FEEDBACK.DISPLAY != undefined &&
                betterdocspublic.FEEDBACK.DISPLAY == true) {
                var URL = betterdocspublic.FEEDBACK.URL + '/' + betterdocspublic.post_id + '&feelings=' + feelings;
                jQuery.ajax({
                    url: URL,
                    method: 'POST',
                    success: function (res) {
                        if (res === true) {
                            $('.betterdocs-article-reactions-heading,.betterdocs-article-reaction-links').fadeOut(1000);
                            $('.betterdocs-article-reactions').html('<p>' + betterdocspublic.FEEDBACK.SUCCESS + '</p>').fadeIn(1000);
                        }
                    }
                });
            }
        });

    });
})(jQuery);
(function ($) {
  class Orion_Cookies {
   constructor() {
    this.cookiesInit();
   }
   cookiesInit() {
    function setCookie(cName, cValue, expDays) {
     let date = new Date()
     date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000)
     const expires = 'expires=' + date.toUTCString()
     document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/'
    }
  
    function getCookie(cName) {
     const name = cName + '='
     const cCoded = decodeURIComponent(document.cookie)
     const cArr = cCoded.split('; ')
     let value
     cArr.forEach(val => {
      if (val.indexOf(name) === 0) value = val.substring(name.length)
     })
  
     return value
    }
  
    const checkConsets = () => {
     document.querySelector('.cookie').style.display = 'none'
     const consents = true
     setCookie('cookies-orion', JSON.stringify(consents), 30);
    }
  
    document.querySelector('.cookie_button').addEventListener('click', () => {
     checkConsets();
    })
  
    document.querySelector('.cookie_close').addEventListener('click', () => {
     document.querySelector('.cookie').style.display = 'none';
    })
  
    function cookieMess() {
     if (!getCookie('cookies-orion')) {
      document.querySelector('.cookie').style.display = 'block';
     } else {
      checkConsets();
     }
    }
  
    window.addEventListener('load', cookieMess)
   }
  }
  /**
   * Menu script
   */
  class Orion_Menu {
   constructor() {
    this.initState();
    this.initEvents();
   }
  
   initState() {
    this.win = $(window);
    this.menuWrapper = $('.site-header');
    this.menuIcon = this.menuWrapper.find('.menu-toggle');
    this.menu = this.menuWrapper.find('.menu-block');
    this.menuItemSubmenu = this.menuWrapper.find('.has-children');
    this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
   }
  
   initEvents() {
    this.menuItemSubmenu.append("<span class='arrow'></span>");
  
    $(window).on('scroll', () => {
     let positionY = this.win.scrollTop();
  
     if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
      this.menuWrapper.addClass('is-fixed');
      return;
     }
  
     if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
      this.menuWrapper.removeClass('is-fixed');
     }
    });
  
    $(window).trigger('scroll');
  
    if (this.menuIcon.length) {
     this.menuIcon.on('click', e => {
      e.preventDefault();
      this.menu.toggleClass('is-active');
      this.menuIcon.toggleClass('is-active');
      $(document.body).toggleClass('no-scroll');
  
      setTimeout(() => {
       this.menu.toggleClass('is-showing');
      }, 150);
     });
    }
  
    setTimeout(() => {
     let menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
     menuSubmenuToggle.each((i, item) => {
      $(item).on('click', (e) => {
       if (this.mobileViewport.matches) {
        e.stopPropagation();
        $(item).parent().toggleClass('is-open');
       }
      });
     });
    }, 0);
   }
  }
  /*
   * Tabs script
   */
  class Orion_Tabs {
    constructor() {
      this.initState();
    }
  
    initState() {
      this.currentIndex = 0;
      this.win = jQuery(window);
      this.wrapper = $('.js-tabs');
      this.tabs = this.wrapper.find('.tablinks-wrapper .tablinks');
      this.tabsSelect = this.wrapper.find('#faq-category');
      this.contents = this.wrapper.find('.tabcontent-wrapper .tabcontent');
      this.animationInProgress = false;
  
      if (this.tabs.length) {
        this.initTabsEvents();
      }
  
      if (this.tabsSelect.length) {
        this.initTabsSelectEvents();
      }
    }
  
    initTabsEvents() {
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs.eq(i).on('click', () => {
          this.tabs.removeClass('is-active');
          this.tabs.eq(i).addClass('is-active');
          this.contents.removeClass('is-active');
          this.contents.eq(i).addClass('is-active');
          this.animationInProgress = true;
  
          if (this.contents.eq(i).find('.tabcontent-list').length) {
            this.contents.eq(i).find('.tabcontent-list .trips-list').css('margin-left', 0);
            this.contents.eq(i).find('.tabcontent-list .trips-list').attr('data-current-item', 0);
            this.contents.eq(i).find('.prev').addClass('is-disabled')
          }
        });
      }
    }
  
    initTabsSelectEvents() {
      this.tabsSelect.on('change', (e) => {
        $(e.target).find('option:selected').each(() => {
          let optionValue = $(e.target).find('option:selected').attr('value');
  
          if (optionValue) {
            $('.faq-content-item').not('[data-id="' + optionValue + '"]').removeClass('active');
            $(".faq-content-item[data-id='" + optionValue + "']").addClass('active');
          } else {
            $(".faq-content-item").removeClass('active');
          }
        });
      }).change();
    }
  }
  
  /**
   * UI elements
   */
  class Orion_UI {
    constructor() {
      this.initSmoothScroll();
      this.detectEdge();
      this.changeColorList();
      this.initTextAccordion();
      this.initOpenSearchInput();
      this.showMoreGalleryImages();
      this.initReserveListPopup();
      this.initExpandText();
      this.showFooterButton();
      this.showProgram();
      this.fixedTripMenu();
      this.activeMenuSection();
      this.showDeadline();
      this.showCurrentTab();
      this.showDescription();
      this.openToggleInfo();
      this.tabsListAgent('.tabs-list li', '.tabs .tab');
      this.tabsListAgent('.sub-tabs-list li', '.sub-tabs .sub-tab');
      this.tabsListAgent('.sup-tabs-list li', '.sup-tabs .sup-tab');
    }
  
    tabsListAgent(valueList, valueTab) {
      let tabsList = document.querySelectorAll('.switcher-list');
      if (tabsList.length > 0) {
        for (let i = 0; i < tabsList.length; i++) {
          let tabsListHead = tabsList[i].querySelectorAll(valueList);
          let tabsListContent = tabsList[i].querySelectorAll(valueTab);
  
          for (let k = 0; k < tabsListHead.length; k++) {
            tabsListHead[k].addEventListener('click', function (e) {
              e.preventDefault();
              tabsListHead.forEach(el => {
                el.classList.remove('active');
              })
              tabsListContent.forEach(el => {
                el.classList.remove('active');
              })
              tabsListHead[k].classList.add('active');
              tabsListContent[k].classList.add('active');
  
              tabsListHead[k].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              });
  
              if (tabsListContent[k].querySelectorAll('li[data-tab]').length > 0) {
                tabsListContent[k].querySelectorAll('li[data-tab]').forEach(el => {
                  el.classList.remove('active');
                });
  
                tabsListContent[k].querySelectorAll('li[data-tab]')[0].classList.add('active');
                tabsListContent[k].querySelectorAll('li[data-tab]')[0].scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'center'
                });
              }
  
              if (tabsListContent[k].querySelectorAll('li[data-tab-id]').length > 0) {
                tabsListContent[k].querySelectorAll('li[data-tab-id]').forEach(el => {
                  el.classList.remove('active');
                });
  
                tabsListContent[k].querySelectorAll('li[data-tab-id]')[0].classList.add('active');
              }
            })
          }
        }
      }
    }
  
    showFooterButton() {
      let goTopButton = document.querySelector('.go-top');
      if (!goTopButton) return;
      window.addEventListener('scroll', function () {
        if (window.scrollY > 500) {
          goTopButton.style.opacity = '1';
          goTopButton.style.zIndex = '22'
        } else {
          goTopButton.style.opacity = '0';
          goTopButton.style.zIndex = '-4'
        }
      })
    }
  
    showProgram() {
      let programContainer = document.querySelectorAll('.program-list.has-more-sections');
      if (!programContainer.length) {
        return
      }
      for (let i = 0; i < programContainer.length; i++) {
        let buttonProgram = programContainer[i].querySelector('.see-more-programs');
        let hiddenPrograms = programContainer[i].querySelectorAll('.wp-block-media-text.with_hide_content');
  
        buttonProgram.addEventListener('click', function (e) {
          e.preventDefault();
          hiddenPrograms.forEach(elements => {
            elements.classList.remove('hidden');
          })
          buttonProgram.style.display = 'none';
        })
      }
    }
  
    initSmoothScroll() {
      $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 180
            }, 1000);
          }
        }
      });
    }
  
    detectEdge() {
      if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        document.body.classList.add('browser--is-edge')
      }
    }
  
    changeColorList() {
      let colorList = $('.color-list-item');
  
      if (!colorList.length) {
        return
      }
  
      for (let i = 0; i < colorList.length; i++) {
        let colorListDataColor = colorList.eq(i).attr('data-color');
        colorList.eq(i).find('.color-list li .color-dot').css('background', colorListDataColor);
      }
    }
  
    initTextAccordion() {
      if ($(document.body).hasClass('js-ui-accordion-initialized')) {
        return;
      }
  
      $(document.body).addClass('js-ui-accordion-initialized');
  
      $(".js-accordion").each(function (i, item) {
        $(item).find('.js-accordion-content').css('height', 0);
  
        $(item).on("click", function () {
          let item = $(this);
          let contentWrapper = item.find('.js-accordion-content');
          let contentText = item.find('.js-accordion-content > div');
          let contentTitle = item.find('.js-accordion-title > p');
          let contentTitleText = item.find('.js-accordion-title > p > .text');
  
          item.toggleClass('active');
          let newHeight = contentText.outerHeight();
  
          if (item.hasClass('active')) {
            contentWrapper.css('height', 0);
  
            setTimeout(function () {
              contentWrapper.css('height', newHeight + 'px');
            }, 0);
  
            setTimeout(function () {
              contentWrapper.css('height', 'auto');
            }, 500);
  
            if (item.hasClass('block-accordion__item--file')) {
              contentTitleText.text(contentTitle.attr('data-text-less'));
            }
          } else {
            contentWrapper.css('height', newHeight + 'px');
  
            setTimeout(function () {
              contentWrapper.css('height', 0);
            }, 0);
  
            if (item.hasClass('block-accordion__item--file')) {
              contentTitleText.text(contentTitle.attr('data-text-more'));
            }
          }
        });
      });
    }
  
    initOpenSearchInput() {
      let searchWrapper = $('.search-block');
      let searchIcon = searchWrapper.find('.open-search');
      let searchInput = searchWrapper.find('.search-form');
  
      $(window).on('click', (e) => {
        searchInput.removeClass('is-active');
      });
  
      searchIcon.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        searchInput.toggleClass('is-active').focus();
      });
  
      searchInput.on('click', (e) => {
        e.stopPropagation();
      })
    }
  
    showMoreGalleryImages() {
      let showMoreImages = $('.show-more-gallery');
  
      if (!showMoreImages.length) {
        return
      }
  
      let gallery = showMoreImages.parents('.gallery-grid-wrapper');
      let galleryMoreImages = gallery.find('.gallery-other-images');
  
      if (galleryMoreImages.children().length == 0) {
        showMoreImages.addClass('is-hidden');
      }
  
      showMoreImages.on('click', (e) => {
        e.preventDefault();
        galleryMoreImages.removeClass('is-hidden');
        showMoreImages.addClass('is-hidden');
      });
    }
  
    initReserveListPopup() {
      let reservePopup = $('.reserve-list-popup');
      let openPopupBtn = $('#show-reserve-form-button');
      let closeBtn = reservePopup.find('.popup-close');
  
      openPopupBtn.on('click', (e) => {
        e.preventDefault();
        $(document.body).addClass('no-scroll');
      });
  
      closeBtn.on('click', (e) => {
        e.preventDefault();
        reservePopup.removeClass('active');
        $(document.body).removeClass('no-scroll');
      });
    }
  
    initExpandText() {
      let expandText = document.querySelectorAll('.expand-text');
  
      for (let i = 0; i < expandText.length; i++) {
        if (!expandText[i].getAttribute('data-js-initialized')) {
          expandText[i].setAttribute('data-js-initialized', true);
  
          let expandLink = expandText[i].querySelector('.expand-text__link');
          let expandTextContent = expandText[i].querySelector('.expand-text__inner');
          let expandTextContentText = expandText[i].querySelector('.expand-text__inner > div');
  
          if (expandLink) {
            expandTextContent.style.height = 0 + 'px';
            expandLink.classList.remove('expand-text__link--open');
            expandLink.addEventListener('click', (e) => {
              e.preventDefault();
              expandTextContent.classList.toggle('expand-text__inner--expanded');
              let newHeight = expandTextContentText.offsetHeight;
  
              if (expandTextContent.classList.contains('expand-text__inner--expanded')) {
                expandTextContent.style.height = 0 + 'px';
                expandLink.classList.remove('expand-text__link--open');
                expandLink.innerText = expandLink.getAttribute('data-text-less');
  
                setTimeout(() => {
                  expandTextContent.style.height = (newHeight + 'px');
                  expandLink.classList.add('expand-text__link--open');
                }, 0);
  
                setTimeout(() => {
                  expandTextContent.style.height = 'auto';
                }, 500);
              } else {
                expandTextContent.style.height = (newHeight + 'px');
                expandLink.classList.add('expand-text__link--open');
                expandLink.innerText = expandLink.getAttribute('data-text-more');
  
                setTimeout(() => {
                  expandTextContent.style.height = 0 + 'px';
                  expandLink.classList.remove('expand-text__link--open');
                }, 0);
              }
            });
          }
        }
      }
    }
  
    fixedTripMenu() {
      var tripMenu = $('.navigation-inner-page');
      var headerHeight = document.querySelector('.page-header');
      var mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
      if (!mobileViewport.matches) {
        return
      }
      $(window).on('scroll', () => {
        let positionYScroll = $(window).scrollTop();
  
        if (!tripMenu || !headerHeight) {
          return
        }
  
        if (positionYScroll > (headerHeight.getBoundingClientRect().height + 150) && !tripMenu.hasClass('fixed-menu')) {
          tripMenu.addClass('fixed-menu');
          return;
        }
  
        if (positionYScroll <= (headerHeight.getBoundingClientRect().height + 150) && tripMenu.hasClass('fixed-menu')) {
          tripMenu.removeClass('fixed-menu');
        }
      });
  
      $(window).trigger('scroll');
    }
  
    showCurrentTab() {
      var mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
      if (!mobileViewport.matches) {
        return
      }
      let currentTabList = document.querySelectorAll('.navigation-inner-page');
      if (currentTabList.length > 0) {
        for (let i = 0; i < currentTabList.length; i++) {
          let currentTabItemsActive = currentTabList[i].querySelector('active');
          if (currentTabItemsActive) {
            currentTabItemsActive.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
          }
  
          currentTabList[i].querySelectorAll('a').forEach(el => {
            el.addEventListener('click', function (e) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
            })
          })
        }
      }
    }
  
    activeMenuSection() {
      let pageOffSetPosition;
      var mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
      let menu = document.querySelector('.sidebar-menu');
      let lastActiveId;
      if (!menu) {
        return
      }
      let sections = document.querySelectorAll('DIV[ID]');
      if (!sections.length) {
        return
      }
      if (!mobileViewport.matches) {
        pageOffSetPosition = document.querySelector('.site-header').getBoundingClientRect().height + 115;
      } else {
        pageOffSetPosition = document.querySelector('.site-header').getBoundingClientRect().height + document.querySelector('.site-header').getBoundingClientRect().height + 70;
      }
  
      window.addEventListener('scroll', function () {
        let current = '';
        document.querySelectorAll('.navigation-inner-page a').forEach(link => {
          link.classList.remove('active');
        })
  
        sections.forEach((section) => {
          if (section.getBoundingClientRect().top <= pageOffSetPosition) {
            current = section.getAttribute('id');
            sections.forEach(elem => {
              elem.classList.remove('active');
            })
            section.classList.add('active');
          }
        })
  
        if (!current) {
          return
        } else {
          document.querySelectorAll('.navigation-inner-page a').forEach(link => {
            if (link.classList.contains('active')) {
              return
            } else {
              if (link.href.includes(current)) {
                this.document.querySelector('.active').classList.remove('active');
                link.classList.add('active');
  
                if (!current || current === lastActiveId) return;
                lastActiveId = current;
                if (mobileViewport.matches) {
                  link.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                  });
                }
              }
            }
          })
        }
      })
    }
  
    showDeadline() {
      let containerReservation = document.querySelector('.form_date_check');
      if (!containerReservation) {
        return
      }
      let deadlineList = containerReservation.querySelector('UL');
      let deadlineContainer = containerReservation.querySelector('.content_container');
      let deadlineItem = deadlineList.querySelectorAll('LI A');
      let heightElement = deadlineList.scrollHeight;
      for (let i = 0; i < deadlineItem.length; i++) {
        if (deadlineItem[i].classList.contains('current')) {
          deadlineItem[i].parentElement.remove();
          deadlineContainer.append(deadlineItem[i]);
        }
  
        if (deadlineItem.length < 2) {
          deadlineContainer.classList.add('without-menu')
        }
  
        if (deadlineItem[i].classList.contains('current')) {
          deadlineItem[i].addEventListener('click', function (e) {
            e.preventDefault();
            if (deadlineItem.length > 1) {
              if (deadlineList.classList.contains('active')) {
                deadlineContainer.classList.remove('active');
                setTimeout(() => {
                  deadlineList.classList.remove('active');
                }, 400);
                deadlineList.style.height = `0px`;
              } else {
                if (deadlineItem.length >= 4) {
                  deadlineList.style.height = `270px`;
                } else {
                  setTimeout(() => {
                    deadlineList.style.height = `auto`;
                  }, 100);
                  deadlineList.style.height = `270px`;
                }
                deadlineList.classList.add('active');
                deadlineContainer.classList.add('active');
              }
            }
          })
        }
      }
    }
  
    showDescription() {
      let descProductButtons = document.querySelectorAll('.js-open-product-desc');
  
      if (descProductButtons.length > 0) {
        for (let i = 0; i < descProductButtons.length; i++) {
          descProductButtons[i].addEventListener('click', function (e) {
            e.preventDefault();
            const parentItem = this.closest('.trip-item');
            const aboutItem = parentItem.querySelector('.about-item');
            const textButton = parentItem.querySelector('.btn.js-open-product-desc')
            aboutItem.classList.toggle('active');
            setTimeout(() => {
              if (aboutItem.classList.contains('active')) {
                textButton.textContent = 'Pokaż mniej';
              } else {
                textButton.textContent = 'Dowiedz się więcej';
              }
            }, 10);
          });
        }
      }
  
    }
  
    openToggleInfo() {
      let toggleInfo = document.querySelectorAll('.toggle-wrapper');
      if (toggleInfo.length > 0) {
        for (let i = 0; i < toggleInfo.length; i++) {
          let toggleActivator = toggleInfo[i].querySelector('.toggle-title');
          if (toggleActivator) {
            toggleActivator.addEventListener('click', function (e) {
              e.preventDefault();
              toggleInfo[i].classList.toggle('active');
            })
          }
        }
      }
    }
  }
  class Orion_FormHelper {
      constructor(formElement) {
          this.formElement = formElement;
          this.rules = {
              required: {
                  validator: (value, field) => {
                      if (field.attr('type') === 'checkbox') {
                          return field.prop('checked');
                      }
  
                      if (field.attr('type') === 'radio') {
                          let selectedValueExists = field.parents('.form-item').find('input[type="radio"]:checked').length;
                          return !!selectedValueExists;
                      }
  
                      if (field.attr('type') === 'file') {
                          let selectedFileExists = field[0].files.length;
                          return !!selectedFileExists;
                      }
  
                      return !!value;
                  },
                  errorText: 'Pole jest wymagane'
              },
              requiredIfDateToVisible: {
                  validator: (value, field) => {
                      let dateToField = field.parents('form').find('[data-val-name="date_to"]');
  
                      if (dateToField.length && dateToField.hasClass('is-hidden')) {
                          return true;
                      }
  
                      return !!value;
                  },
                  errorText: 'Pole jest wymagane'
              },
              min: {
                  validator: (value, range) => parseFloat(value) >= parseFloat(range),
                  errorText: (range) => 'Wartość nie może być mniejsza niż ' + range
              },
              max: {
                  validator: (value, range) => parseFloat(value) <= parseFloat(range),
                  errorText: (range) => 'Wartość nie może być większa niż ' + range
              },
              email: {
                  validator: (value) => value.indexOf('@') > 0 && value.indexOf('.') > -1,
                  errorText: 'Podaj prawidłowy adres e-mail'
              },
              phone: {
                validator: (value) => (/^[\+]{0,}[0-9]{7,}$/gmi).test(value.replace(/ /gmi, '')),
                errorText: 'Podaj prawidłowy numer telefonu (może zawierać jedynie liczby i spacje)'
              },
              postcode: {
                  validator: (value) => typeof value === "string" && (new RegExp(/^[0-9]{2,2}\-[0-9]{3,3}$/gmi).test(value) || new RegExp(/^[0-9]{5,5}$/gmi).test(value)),
                  errorText: 'Kod pocztowy musi być podany w formacie XX-XXX'
              }
          };
          this.dependencies = {};
      }
  
      formDependencies(config) {
          for (let i = 0; i < config.length; i++) {
              if (config[i].useCollection) {
                  let triggerSelector = config[i].dependsOn;
                  let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
                  let callback = config[i].elementsToShow;
                  let triggerElement = this.formElement.find(triggerSelector);
                  let fieldElements = this.formElement.find('*[data-val-name="' + fieldName + '"]');
  
                  triggerElement.on('input', (e) => {
                      fieldElements.addClass('is-hidden');
  
                      for (let j = 0; j < fieldElements.length; j++) {
                          this.resetField(fieldElements.eq(j));
                      }
  
                      let elementsToShow = callback($(e.target).val());
                      elementsToShow.removeClass('is-hidden');
                  });
              } else {
                  let triggerSelector = config[i].dependsOn;
                  let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
                  let callback = config[i].showOn;
                  let triggerElement = this.formElement.find(triggerSelector);
                  let fieldElement = this.formElement.find('*[data-val-name="' + fieldName + '"]');
  
                  triggerElement.on('input', (e) => {
                      if (callback($(e.target).val())) {
                          fieldElement.removeClass('is-hidden');
                      } else {
                          fieldElement.addClass('is-hidden');
                          this.resetField(fieldElement);
                      }
                  });
              }
          }
      }
  
      resetField(fieldWrapper) {
          if (fieldWrapper.find('input').length) {
              if (fieldWrapper.find('input').attr('type') === 'radio') {
                  fieldWrapper.find('input').prop('checked', false);
              } else {
                  fieldWrapper.find('input').val('');
              }
  
              fieldWrapper.find('input').trigger('input');
          } else if (fieldWrapper.find('select').length) {
              fieldWrapper.find('select').val('');
              fieldWrapper.find('select').trigger('input');
          } else if (fieldWrapper.find('textarea').length) {
              fieldWrapper.find('textarea').val('');
              fieldWrapper.find('textarea').trigger('input');
          }
      }
  
      formValidate() {
          // pobieramy wszystkie pole
          let fields = this.formElement.find('*[data-val-validation]');
          let formIsValid = true;
  
          for (let i = 0; i < fields.length; i++) {
              // pomijamy ukryte pola
              if (fields.eq(i).parents('[data-val-name]').hasClass('is-hidden')) {
                  continue;
              }
  
              let fieldValue = fields.eq(i).val();
              let validationRules = fields.eq(i).attr('data-val-validation');
              validationRules = validationRules.split('|');
              let fieldIsValid = true;
              let fieldErrorMessage = fields.eq(i).parents('.form-item').find('.validation-error');
  
              for (let j = 0; j < validationRules.length; j++) {
                  let validationRule = validationRules[j];
  
                  if (validationRule.indexOf(':') > -1) {
                      let ruleName = validationRule.split(':')[0];
                      let range = validationRule.split(':')[1];
  
                      if (!this.rules[ruleName].validator(fieldValue, range)) {
                          fieldIsValid = false;
                          fieldErrorMessage.text(this.rules[ruleName].errorText(range));
                          break;
                      }
                  } else {
                      if (!this.rules[validationRule].validator(fieldValue, fields.eq(i))) {
                          fieldIsValid = false;
                          fieldErrorMessage.text(this.rules[validationRule].errorText);
                          break;
                      }
                  }
              }
  
              if (fieldIsValid) {
                  fieldErrorMessage.addClass('is-hidden');
                  fieldErrorMessage.text('');
              } else {
                  formIsValid = false;
                  fieldErrorMessage.removeClass('is-hidden');
                  fields.eq(i).one('input', () => {
                      fieldErrorMessage.addClass('is-hidden');
                      fieldErrorMessage.text('');
                  });
              }
          }
  
          return formIsValid;
      }
  }
  /**
   * Homepage slider script
   */
  class Orion_HomeSlider {
    constructor() {
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.sliderWrapper = $('.home-slider');
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.home-slider-list');
      this.items = this.list.find('.home-slider-item');
      this.currentItem = 0;
      this.animationInProgress = false;
    }
  
    initEvents() {
      setTimeout(() => {
        this.showNextSlide();
      }, 4500);
  
      if (this.sliderWrapper.length) {
        this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
        this.nextBtn.on('click', e => {
          e.preventDefault();
  
          if (e.originalEvent) {
            this.blankSlide = true;
          }
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem++;
          this.animationInProgress = true;
  
          if (this.currentItem >= this.items.length) {
            this.currentItem = 0;
          }
  
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        this.prevBtn.on('click', e => {
          e.preventDefault();
  
          if (e.originalEvent) {
            this.blankSlide = true;
          }
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem--;
          this.animationInProgress = true;
  
          if (this.currentItem < 0) {
            this.currentItem = this.items.length - 1;
          }
  
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        this.swipeEffect.on('swipe', ev => {
          if (ev.type === 'swipe' && ev.direction === 2) {
            this.nextBtn.trigger('click');
          }
    
          if (ev.type === 'swipe' && ev.direction === 4) {
            this.prevBtn.trigger('click');
          }
        });
      }
    }
  
    showNextSlide() {
      if (this.blankSlide) {
        this.blankSlide = false;
      } else {
        this.nextBtn.trigger('click');
      }
  
      setTimeout(() => {
        this.showNextSlide();
      }, 5500);
    }
  }
  
  /**
   * Team slider script
   */
  class Orion_TeamSlider {
    constructor() {
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.sliderWrapper = $('.team-slider');
      this.dotsList = this.sliderWrapper.find('.slider-dots');
      this.dots = this.sliderWrapper.find('.dot');
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.team-slider-list');
      this.items = this.list.find('.team-slider-item');
      this.currentItem = 0;
      this.itemsPerPage = 4;
      this.animationInProgress = false;
    }
  
    initEvents() {
      this.initRWD();
  
      if (this.sliderWrapper.length) {
        this.initUI();
      }
    }
  
    initUI() {
      this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
      this.prevBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem--;
        this.animationInProgress = true;
  
        if (this.currentItem === 0) {
          this.prevBtn.addClass('is-hidden');
        }
  
        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
        this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
        this.nextBtn.removeClass('is-hidden');
  
        setTimeout(() => {
          this.animationInProgress = false;
        }, 250);
      });
  
      this.nextBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem++;
        this.animationInProgress = true;
  
        if (this.currentItem === (this.items.length - this.itemsPerPage)) {
          this.nextBtn.addClass('is-hidden');
        }
  
        if (this.currentItem >= this.items.length) {
          this.currentItem = (this.items.length - 1);
        }
  
        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
        this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
        this.prevBtn.removeClass('is-hidden');
  
        setTimeout(() => {
          this.animationInProgress = false;
        }, 250);
      });
  
      for (let i = 0; i < this.dots.length; i++) {
        this.dots.eq(i).on('click', e => {
          e.preventDefault();
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem = i;
          this.animationInProgress = true;
          this.dots.removeClass('is-active');
          this.dots.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
  
          if (this.currentItem === (this.items.length - this.itemsPerPage)) {
            this.nextBtn.addClass('is-hidden');
          } else {
            this.nextBtn.removeClass('is-hidden');
          }
  
          if (this.currentItem > 0) {
            this.prevBtn.removeClass('is-hidden');
          } else {
            this.prevBtn.addClass('is-hidden');
          }
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
      }
  
      this.swipeEffect.on('swipe', ev => {
        if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
          if (this.currentItem < this.dots.length - this.itemsPerPage) {
            this.currentItem++;
          } else {
            this.currentItem = 0;
          }
  
          this.dots.eq(this.currentItem).trigger('click');
        }
  
        if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
          if (this.currentItem > 0) {
            this.currentItem--;
          } else {
            this.currentItem = this.dots.length - this.itemsPerPage;
          }
  
          this.dots.eq(this.currentItem).trigger('click');
        }
      });
    }
  
    initRWD() {
      this.desktopViewport = window.matchMedia('(min-width: 1024px)');
      this.tabletViewport = window.matchMedia('(min-width: 720px) and (max-width: 1023px)');
      this.mobileViewport = window.matchMedia('(min-width: 500px) and (max-width: 719px)');
      this.mobileSmallViewport = window.matchMedia('(max-width: 499px)');
      if (this.desktopViewport.matches) this.updateViewports('desktop');
      if (this.tabletViewport.matches) this.updateViewports('tablet');
      if (this.mobileViewport.matches) this.updateViewports('mobile');
      if (this.mobileSmallViewport.matches) this.updateViewports('mobileSmall');
      this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
      this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
      this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
      this.mobileSmallViewport.addListener(mq => mq.matches ? this.updateViewports('mobileSmall') : false);
  
      if (this.desktopViewport.matches) {
        this.itemsPerPage = 4;
      } else if (this.tabletViewport.matches) {
        this.itemsPerPage = 3;
      } else if (this.mobileViewport.matches) {
        this.itemsPerPage = 2;
      } else if (this.mobileSmallViewport.matches) {
        this.itemsPerPage = 1;
      }
  
      this.toggleDotsVisibility();
  
      this.desktopViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(4);
        }
      });
  
      this.tabletViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(3);
        }
      });
  
      this.mobileViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(2);
        }
      });
  
      this.mobileSmallViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(1);
        }
      });
    }
  
    updateViewports(type) {
      if (this.currentViewport !== type) {
        this.currentItem = 0;
        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
        this.list.css('margin-left', "0%");
        this.currentViewport = type;
        this.prevBtn.addClass('is-hidden');
        this.nextBtn.removeClass('is-hidden');
      }
    }
  
    setItemsPerPage(numberOfItems) {
      this.currentItem = 0;
      this.itemsPerPage = numberOfItems;
      this.dots.removeClass('is-active');
      this.dots.eq(this.currentItem).addClass('is-active');
      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.toggleDotsVisibility();
    }
  
    toggleDotsVisibility() {
      let visibleDots = (this.dots.length - this.itemsPerPage) + 1;
  
      for (let i = 0; i < this.dots.length; i++) {
        let visibilityState = i < visibleDots ? 'block' : 'none';
        this.dots.eq(i).css('display', visibilityState);
      }
  
      if (this.itemsCount - this.itemsPerPage <= 0) {
        this.dotsList.css('display', 'none');
      } else {
        this.dotsList.css('display', 'flex');
      }
    }
  }
  
  /**
   * Testimonials slider script
   */
  class Orion_TestimonialsSlider {
    constructor() {
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.sliderWrapper = $('.testimonials');
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.testimonials-slider-list');
      this.items = this.list.find('.testimonials-slider-item');
      this.listText = this.sliderWrapper.find('.testimonials-slider-text-list');
      this.itemsText = this.sliderWrapper.find('.testimonials-slider-text-item');
      this.currentItem = 0;
      this.animationInProgress = false;
    }
  
    initEvents() {
      if (this.sliderWrapper.length) {
        this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
        this.nextBtn.on('click', e => {
          e.preventDefault();
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem++;
          this.animationInProgress = true;
  
          if (this.currentItem >= this.items.length) {
            this.currentItem = 0;
          }
  
          this.items.removeClass('is-active');
          this.itemsText.removeClass('is-active');
          this.items.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
          this.listText.css('margin-left', (-100 * this.currentItem) + "%");
          this.prevBtn.removeClass('is-hidden');
  
          setTimeout(() => {
            this.itemsText.eq(this.currentItem).addClass('is-active');
          }, 50);
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        this.prevBtn.on('click', e => {
          e.preventDefault();
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem--;
          this.animationInProgress = true;
  
          if (this.currentItem < 0) {
            this.currentItem = this.items.length - 1;
          }
  
          this.items.removeClass('is-active');
          this.items.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
          this.listText.css('margin-left', (-100 * this.currentItem) + "%");
          this.nextBtn.removeClass('is-hidden');
  
          setTimeout(() => {
            this.itemsText.eq(this.currentItem).addClass('is-active');
          }, 100);
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        this.swipeEffect.on('swipe', ev => {
          if (ev.type === 'swipe' && ev.direction === 2) {
            this.nextBtn.trigger('click');
          }
    
          if (ev.type === 'swipe' && ev.direction === 4) {
            this.prevBtn.trigger('click');
          }
        });
      }
    }
  }
  
  /**
   * Text slider script
   */
  class Orion_TextSlider {
    constructor() {
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.sliderWrapper = $('.text-slider');
      this.dotsList = this.sliderWrapper.find('.slider-dots');
      this.dots = this.sliderWrapper.find('.dot');
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.text-slider-list');
      this.items = this.list.find('.text-slider-item');
      this.currentItem = 0;
      this.animationInProgress = false;
    }
  
    initEvents() {
      if (this.sliderWrapper.length) {
        this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
        this.nextBtn.on('click', e => {
          e.preventDefault();
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem++;
          this.animationInProgress = true;
  
          if (this.currentItem >= this.items.length) {
            this.currentItem = 0;
          }
  
          this.dots.removeClass('is-active');
          this.dots.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        this.prevBtn.on('click', e => {
          e.preventDefault();
  
          if (this.animationInProgress) {
            return;
          }
  
          this.currentItem--;
          this.animationInProgress = true;
  
          if (this.currentItem < 0) {
            this.currentItem = this.items.length - 1;
          }
  
          this.dots.removeClass('is-active');
          this.dots.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
  
          setTimeout(() => {
            this.animationInProgress = false;
          }, 550);
        });
  
        for (let i = 0; i < this.dots.length; i++) {
          this.dots.eq(i).on('click', e => {
            e.preventDefault();
    
            if (this.animationInProgress) {
              return;
            }
    
            this.currentItem = i;
            this.animationInProgress = true;
            this.dots.removeClass('is-active');
            this.dots.eq(this.currentItem).addClass('is-active');
            this.list.css('margin-left', (-100 * this.currentItem) + "%");
            
            setTimeout(() => {
              this.animationInProgress = false;
            }, 550);
          });
        }
  
        this.swipeEffect.on('swipe', ev => {
          if (ev.type === 'swipe' && ev.direction === 2) {
            this.nextBtn.trigger('click');
          }
    
          if (ev.type === 'swipe' && ev.direction === 4) {
            this.prevBtn.trigger('click');
          }
        });
      }
    }
  }
  
  /**
   * Cookie Banner
   */
  
  /*
   Connections:
   -------------------------------------------------------------------------------
   * players - every player on website: Vimeo, YouTube, Spreaker
   * linkedin - linkedin analytics
   * newsletter - MailerLite forms
   * google - GTM code
   * fb - Facebook Pixel
   * hotjar - HotJar
   * trafficj - Traffic junky
  */
  
  class Orion_CookieBanner {
    constructor() {
      this.config = {
        debugMode: false,
        userConsents: {
          players: false,
          linkedin: false,
          newsletter: false,
          google: false,
          fb: false,
          hotjar: false,
          trafficj: false
        },
        groups: [
          'players',
          'linkedin',
          'newsletter',
          'google',
          'fb',
          'hotjar',
          'trafficj'
        ]
      };
  
      this.UI = {
        basicWindow: $('.orion-cn-info'),
        extendedWindow: $('.orion-cn-info-extended'),
        buttons: {
          basicShowExtended: $('.orion-cn-info-button-show-extended'),
          basicAcceptAll: $('.orion-cn-info-button-accept-all'),
          basicRejectAll: $('.orion-cn-info-button-reject-all'),
          extendedAcceptAll: $('.orion-cn-info-extended-button-accept-all'),
          extendedSaveConfig: $('.orion-cn-info-extended-button-save-consent'),
          extendedNotNow: $('.orion-cn-info-extended-button-close-without-save')
        },
        checkboxes: {
          players: $('.orion-cn-consent-checkbox[data-consent-type="players"]'),
          linkedin: $('.orion-cn-consent-checkbox[data-consent-type="linkedin"]'),
          newsletter: $('.orion-cn-consent-checkbox[data-consent-type="newsletter"]'),
          google: $('.orion-cn-consent-checkbox[data-consent-type="google"]'),
          fb: $('.orion-cn-consent-checkbox[data-consent-type="fb"]'),
          hotjar: $('.orion-cn-consent-checkbox[data-consent-type="hotjar"]'),
          trafficj: $('.orion-cn-consent-checkbox[data-consent-type="trafficj"]')
        }
      };
  
      if (this.UI.basicWindow.length) {
        this.initEvents();
        this.initPublicAPI();
        this.checkConfig();
      }
    }
  
    checkConfig () {
      let config = Cookies.get('orion-cn-config-v3');
  
      // When no config - show popup
      if (!config) {
        if (this.config.debugMode) {
          console.log('⛔️ Consent config not found - showing popup');
        }
  
        this.showPopup();
        return;
      }
  
      // otherwise - load config without showing popup
      this.loadConfig(config);
    }
  
    loadConfig (configFromCookie) {
      this.config.userConsents.players = configFromCookie.indexOf('players') > -1;
      this.config.userConsents.linkedin = configFromCookie.indexOf('linkedin') > -1;
      this.config.userConsents.newsletter = configFromCookie.indexOf('newsletter') > -1;
      this.config.userConsents.google = configFromCookie.indexOf('google') > -1;
      this.config.userConsents.fb = configFromCookie.indexOf('fb') > -1;
      this.config.userConsents.hotjar = configFromCookie.indexOf('hotjar') > -1;
      this.config.userConsents.trafficj = configFromCookie.indexOf('trafficj') > -1;
  
      if (this.config.debugMode) {
        console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(this.config.userConsents)));
      }
    }
  
    initEvents () {
      $(document).find('a[href="#cookie-settings"]').on('click', e => {
        e.preventDefault();
        this.showExtendedPopup();
      });
  
      this.UI.buttons.basicShowExtended.on('click', e => {
        e.preventDefault();
        this.closePopup();
        this.showExtendedPopup();
      });
  
      this.UI.buttons.basicAcceptAll.on('click', e => {
        e.preventDefault();
        this.giveConsentForAll();
        this.closePopup();
      });
  
      this.UI.buttons.basicRejectAll.on('click', e => {
        e.preventDefault();
        this.resetCookieConfig();
        this.closePopup();
      });
  
      this.UI.buttons.extendedAcceptAll.on('click', e => {
        e.preventDefault();
        this.giveConsentForAll();
        this.closeExtendedPopup();
      });
  
      this.UI.buttons.extendedSaveConfig.on('click', e => {
        e.preventDefault();
        this.saveConsent();
        this.closeExtendedPopup();
      });
  
      this.UI.buttons.extendedNotNow.on('click', e => {
        e.preventDefault();
        this.closeExtendedPopup();
      });
    }
  
    setCheckboxes () {
      for (let i = 0; i < this.config.groups.length; i++) {
        let group = this.config.groups[i];
        
        if (this.config.userConsents[group]) {
          this.UI.checkboxes[group].prop('checked', true);
        } else {
          this.UI.checkboxes[group].prop('checked', false);
        }
      }
    }
  
    initPublicAPI () {
      window.orionCookieBanner = {
        giveConsentAndSave: (type) => this.giveConsentAndSave(type),
        giveConsentAndSaveAndLoad: (type) => this.giveConsentAndSave(type, true),
        showExtendedPopup: () => this.showExtendedPopup,
        getConsentStatus: (type) => this.getConsentStatus(type)
      };
    }
  
    showPopup () {
      this.UI.basicWindow.removeClass('is-hidden');
    }
  
    closePopup () {
      this.UI.basicWindow.addClass('is-hidden');
    }
  
    showExtendedPopup () {
      this.UI.extendedWindow.removeClass('is-hidden');
      $(document.body).addClass('no-scroll');
      this.setCheckboxes();
    }
  
    closeExtendedPopup () {
      this.UI.extendedWindow.addClass('is-hidden');
      $(document.body).removeClass('no-scroll');
    }
  
    giveConsentForAll () {
      this.giveConsent('players');
      this.giveConsent('linkedin');
      this.giveConsent('newsletter');
      this.giveConsent('google');
      this.giveConsent('fb');
      this.giveConsent('hotjar');
      this.giveConsent('trafficj');
      this.saveConsentConfigInCookie();
    }
  
    giveConsent (type, forceOnLoad = false) {
      if (this.config.debugMode) {
        console.log('✅ User gave consent:', type);
      }
  
      this.config.userConsents[type] = true;
  
      if (type === 'players') {
        this.allowPlayers();
        return;
      }
  
      if (type === 'linkedin') {
        this.allowLinkedin();
        return;
      }
  
      if (type === 'newsletter') {
        this.allowNewsletter();
        return;
      }
  
      if (type === 'google') {
        this.allowGoogle();
        return;
      }
  
      if (type === 'fb') {
        this.allowFB();
        return;
      }
  
      if (type === 'hotjar') {
        this.allowHotJar();
        return;
      }
  
      // TrafficJ not requires any direct action after allowing it
    }
  
    giveConsentAndSave (type, forceOnLoad = false) {
      this.giveConsent(type, forceOnLoad);
      this.saveConsentConfigInCookie();
    }
  
    saveConsent () {
      let consentCompare = this.compareConsents();
      this.setConsentBasedOnCheckboxes();
  
      // if some consent has been removed
      if (consentCompare === 'some-rejected') {
        this.saveConsentConfigInCookie();
        window.location.reload();
        return;
      }
  
      // otherwise - if some consent has been added
      this.saveConsentConfigInCookie();
    }
  
    setConsentBasedOnCheckboxes () {
      for (let i = 0; i < this.config.groups.length; i++) { 
        let group = this.config.groups[i];
  
        if (!!this.UI.checkboxes[group].prop('checked')) {
          this.giveConsent(group);
        }
        
        this.config.userConsents[group] = !!this.UI.checkboxes[group].prop('checked');
      }
    }
  
    saveConsentConfigInCookie () {
      let configToSave = [];
  
      for (let i = 0; i < this.config.groups.length; i++) {
        let group = this.config.groups[i];
  
        if (this.config.userConsents[group]) {
          configToSave.push(group);
        }
      }
  
      if (configToSave.length) {
        Cookies.set('orion-cn-config-v3', configToSave.join(';'), { expires: 180 });
  
        if (this.config.debugMode) {
          console.log('🍪 Consent config saved in the cookie');
        }
      } else {
        this.resetCookieConfig();
      }
    }
  
    resetCookieConfig () {
      Cookies.set('orion-cn-config-v3', 'null', { expires: 180 });
  
      if (this.config.debugMode) {
        console.log('🗑 User rejected all cookies - save empty config cookie');
      }
    }
  
    compareConsents () {
      let someRejected = false;
  
      for (let i = 0; i < this.config.groups.length; i++) {
        let group = this.config.groups[i];
  
        if (this.config.userConsents[group] && !this.UI.checkboxes[group].prop('checked')) {
          someRejected = true;
        }
      }
  
      if (someRejected) {
        if (this.config.debugMode) {
          console.log('🔄 Some consents has been rejected - website reload needed');
        }
  
        return 'some-rejected';
      }
  
      if (this.config.debugMode) {
        console.log('ℹ️ User not rejected any consents - website reload not needed');
      }
  
      return 'some-added-or-not-changed';
    }
  
    getConsentStatus (type) {
      return !!this.config.userConsents[type];
    }
  
    allowPlayers () {
      if (window.orionUnlocked.indexOf('players') > -1) {
        return;
      }
  
      window.orionUnlockPlayers(true);
    }
  
    allowNewsletter () {
      if (window.orionUnlocked.indexOf('newsletter') > -1) {
        return;
      }
  
      window.orionUnlockConsentedScript('newsletter', 'body', true, true);
    }
  
    allowGoogle () {
      if (window.orionUnlocked.indexOf('google') > -1) {
        return;
      }
  
      window.orionUnlockConsentedScript('google', 'head', true);
    }
  
    allowLinkedin () {
      if (window.orionUnlocked.indexOf('linkedin') > -1) {
        return;
      }
  
      window.orionUnlockConsentedScript('linkedin', 'head', true);
    }
  
    allowFB () {
      if (window.orionUnlocked.indexOf('fb') > -1) {
        return;
      }
  
      window.orionUnlockConsentedScript('fb', 'head', true);
    }
  
    allowHotJar () {
      if (window.orionUnlocked.indexOf('hotjar') > -1) {
        return;
      }
  
      window.orionUnlockConsentedScript('hotjar', 'head', true);
    }
  }
  
  /**
   * Gallery slider script
   */
  class Orion_GallerySlider {
    constructor() {
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.sliderWrapper = $('.gallery-slider');
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.gallery-slider-list');
      this.items = this.list.find('.gallery-slider-item');
      this.currentItem = 0;
      this.itemsPerPage = 3;
      this.animationInProgress = false;
    }
  
    initEvents() {
      this.initRWD();
  
      if (this.sliderWrapper.length) {
        this.initUI();
      }
    }
  
    initUI () {        
      this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
      this.prevBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem--;
        this.animationInProgress = true;
  
        if (this.currentItem === 0) {
          this.prevBtn.addClass('is-hidden');
        }
  
        this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
        this.nextBtn.removeClass('is-hidden');
  
        setTimeout(() => {
            this.animationInProgress = false;
        }, 250);
      });
  
      this.nextBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem++;
        this.animationInProgress = true;
  
        if (this.currentItem === (this.items.length - this.itemsPerPage)) {
          this.nextBtn.addClass('is-hidden');
        }
  
        if (this.currentItem >= this.items.length) {
          this.currentItem = (this.items.length - 1);
        }
  
        this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
        this.prevBtn.removeClass('is-hidden');
  
        setTimeout(() => {
          this.animationInProgress = false;
        }, 250);
      });
  
      this.swipeEffect.on('swipe', ev => {
        if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
          if (this.currentItem > this.items.length - this.itemsPerPage) {
            return
          }
  
          this.nextBtn.trigger('click');
        }
  
        if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
          if (this.currentItem <= 0) {
            return
          }
  
          this.prevBtn.trigger('click');
        }
      });
    }
  
    initRWD () {
      this.desktopViewport = window.matchMedia('(min-width: 1024px)');
      this.tabletViewport = window.matchMedia('(min-width: 720px) and (max-width: 1023px)');
      this.mobileViewport = window.matchMedia('(max-width: 719px)');
      if (this.desktopViewport.matches) this.updateViewports('desktop');
      if (this.tabletViewport.matches) this.updateViewports('tablet');
      if (this.mobileViewport.matches) this.updateViewports('mobile');
      this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
      this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
      this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
  
      if (this.desktopViewport.matches) {
        this.itemsPerPage = 3;
      } else if (this.tabletViewport.matches) {
        this.itemsPerPage = 2;
      } else if (this.mobileViewport.matches) {
        this.itemsPerPage = 1;
      }
  
      this.desktopViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(3);
        }
      });
  
      this.tabletViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(2);
        }
      });
  
      this.mobileViewport.addListener(mq => {
        if (mq.matches) {
          this.setItemsPerPage(1);
        }
      });
    }
  
    updateViewports (type) {
      if (this.currentViewport !== type) {
        this.currentItem = 0;
        this.list.css('margin-left', "0%");
        this.currentViewport = type;
        this.prevBtn.addClass('is-hidden');
        this.nextBtn.removeClass('is-hidden');
      }
    }
  
    setItemsPerPage (numberOfItems) {
      this.currentItem = 0;
      this.itemsPerPage = numberOfItems;
      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");  
    }
  }
  
  /**
   * Tabs trips script
   */
  class Orion_TabsTripsSlider {
      constructor(wrapper) {
          this.sliderWrapper = wrapper;
          this.initEvents();
      }
  
      initEvents() {
          this.prevBtn = this.sliderWrapper.find('.prev');
          this.nextBtn = this.sliderWrapper.find('.next');
          this.list = this.sliderWrapper.find('.trips-list');
          this.items = this.list.find('.trip-item');
          this.currentItem = this.list.attr('data-current-item');
          this.itemsPerPage = 4;
          this.animationInProgress = false;
          this.initRWD();
  
          if (this.sliderWrapper.length) {
              this.initUI();
          }
      }
  
      initUI() {
          this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
          this.prevBtn.on('click', e => {
              e.preventDefault();
  
              if (this.animationInProgress) {
                  return;
              }
  
              this.currentItem--;
              this.animationInProgress = true;
  
              if (this.currentItem === 0) {
                  this.prevBtn.addClass('is-hidden');
              }
  
              this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
              this.nextBtn.removeClass('is-hidden');
  
              setTimeout(() => {
                  this.animationInProgress = false;
              }, 250);
          });
  
          this.nextBtn.on('click', e => {
              e.preventDefault();
  
              if (this.animationInProgress) {
                  return;
              }
  
              this.currentItem++;
              this.animationInProgress = true;
  
              if (this.currentItem === (this.items.length - this.itemsPerPage)) {
                  this.nextBtn.addClass('is-hidden');
              }
  
              if (this.currentItem >= this.items.length) {
                  this.currentItem = (this.items.length - 1);
              }
  
              this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
              this.prevBtn.removeClass('is-hidden');
  
              setTimeout(() => {
                  this.animationInProgress = false;
              }, 250);
          });
  
          this.swipeEffect.on('swipe', ev => {
              if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
                  if (this.currentItem > this.items.length - this.itemsPerPage) {
                      this.currentItem = 0;
                  }
  
                  this.nextBtn.trigger('click');
              }
  
              if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
                  if (this.currentItem <= 0) {
                      return
                  }
  
                  this.prevBtn.trigger('click');
              }
          });
  
          if (this.items.length === 0) {
              var content = this.list.parents('.tabcontent');
              var paragraph = '<p class="no-trip">Brak aktualnych ofert</p>';
              content.find('.tabcontent-inner').css('display', 'none');
              content.find('.btn').text('Zobacz wyjazdy archiwalne');
              content.prepend(paragraph)
          }
      }
  
      initRWD() {
          this.fullHDViewport = window.matchMedia('(min-width: 1201px)');
          this.desktopViewport = window.matchMedia('(min-width: 1025px) and (max-width: 1200px)');
          this.tabletViewport = window.matchMedia('(min-width: 561px) and (max-width: 1024px)');
          this.mobileViewport = window.matchMedia('(max-width: 560px)');
          if (this.desktopViewport.matches) this.updateViewports('fullhd');
          if (this.desktopViewport.matches) this.updateViewports('desktop');
          if (this.tabletViewport.matches) this.updateViewports('tablet');
          if (this.mobileViewport.matches) this.updateViewports('mobile');
          this.fullHDViewport.addListener(mq => mq.matches ? this.updateViewports('fullhd') : false);
          this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
          this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
          this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
  
          if (this.fullHDViewport.matches) {
              if (this.items.length <= 4) {
                  this.prevBtn.css('display', 'none')
                  this.nextBtn.css('display', 'none')
              }
              this.itemsPerPage = 4;
          } else if (this.desktopViewport.matches) {
              if (this.items.length <= 3) {
                  this.prevBtn.css('display', 'none')
                  this.nextBtn.css('display', 'none')
              }
              this.itemsPerPage = 3;
          } else if (this.tabletViewport.matches) {
              if (this.items.length <= 2) {
                  this.prevBtn.css('display', 'none')
                  this.nextBtn.css('display', 'none')
              }
              this.itemsPerPage = 2;
          } else if (this.mobileViewport.matches) {
              if (this.items.length <= 1) {
                  this.prevBtn.css('display', 'none')
                  this.nextBtn.css('display', 'none')
              }
              this.itemsPerPage = 1;
          }
  
          this.fullHDViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(4);
              }
          });
  
          this.desktopViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(3);
              }
          });
  
          this.tabletViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(2);
              }
          });
  
          this.mobileViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(1);
              }
          });
      }
  
      updateViewports(type) {
          if (this.currentViewport !== type) {
              this.currentItem = 0;
              this.list.css('margin-left', "0%");
              this.currentViewport = type;
              this.prevBtn.addClass('is-hidden');
              this.nextBtn.removeClass('is-hidden');
          }
      }
  
      setItemsPerPage(numberOfItems) {
          this.currentItem = 0;
          this.itemsPerPage = numberOfItems;
          this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      }
  }
  
  /**
   * Small slider script
   */
  class Orion_smallSlider {
      constructor(wrapper) {
          this.sliderWrapper = wrapper;
          this.initEvents();
      }
  
      initEvents() {
          this.prevBtn = this.sliderWrapper.find('.prev');
          this.nextBtn = this.sliderWrapper.find('.next');
          this.dotsList = this.sliderWrapper.find('.slider-dots');
          this.dots = this.sliderWrapper.find('.dot');
          this.list = this.sliderWrapper.find('.slider-list');
          this.items = this.list.find('.slider-item');
          this.currentItem = this.list.attr('data-current-item');
          this.itemsPerPage = 3;
          this.animationInProgress = false;
  
          this.initRWD();
  
          if (this.sliderWrapper.length) {
              this.initUI();
          }
      }
  
      initUI() {
          if (this.items.length <= this.itemsPerPage) {
              this.nextBtn.addClass('is-hidden');
          }
  
          this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
          this.prevBtn.on('click', e => {
              e.preventDefault();
  
              if (this.animationInProgress) {
                  return;
              }
  
              this.currentItem--;
              this.animationInProgress = true;
  
              if (this.currentItem === 0) {
                  this.prevBtn.addClass('is-hidden');
              }
  
              this.dots.removeClass('is-active');
              this.dots.eq(this.currentItem).addClass('is-active');
              this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
              this.nextBtn.removeClass('is-hidden');
  
              setTimeout(() => {
                  this.animationInProgress = false;
              }, 250);
          });
  
          this.nextBtn.on('click', e => {
              e.preventDefault();
  
              if (this.animationInProgress) {
                  return;
              }
  
              this.currentItem++;
              this.animationInProgress = true;
  
              if (this.currentItem === (this.items.length - this.itemsPerPage)) {
                  this.nextBtn.addClass('is-hidden');
              }
  
              if (this.currentItem >= this.items.length) {
                  this.currentItem = (this.items.length - 1);
              }
  
              this.dots.removeClass('is-active');
              this.dots.eq(this.currentItem).addClass('is-active');
              this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
              this.prevBtn.removeClass('is-hidden');
  
              setTimeout(() => {
                  this.animationInProgress = false;
              }, 250);
          });
  
          for (let i = 0; i < this.dots.length; i++) {
              this.dots.eq(i).on('click', e => {
                  e.preventDefault();
  
                  if (this.animationInProgress) {
                      return;
                  }
  
                  this.currentItem = i;
                  this.animationInProgress = true;
                  this.dots.removeClass('is-active');
                  this.dots.eq(this.currentItem).addClass('is-active');
                  this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
  
                  if (this.currentItem === (this.items.length - this.itemsPerPage)) {
                      this.nextBtn.addClass('is-hidden');
                  } else {
                      this.nextBtn.removeClass('is-hidden');
                  }
  
                  if (this.currentItem > 0) {
                      this.prevBtn.removeClass('is-hidden');
                  } else {
                      this.prevBtn.addClass('is-hidden');
                  }
  
                  setTimeout(() => {
                      this.animationInProgress = false;
                  }, 550);
              });
          }
  
          this.swipeEffect.on('swipe', ev => {
              if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
                  if (this.currentItem < this.items.length - this.itemsPerPage) {
                      this.currentItem++;
                  } else {
                      this.currentItem = 0;
                  }
  
                  this.dots.eq(this.currentItem).trigger('click');
              }
  
              if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
                  if (this.currentItem > 0) {
                      this.currentItem--;
                  } else {
                      this.currentItem = this.items.length - this.itemsPerPage;
                  }
  
                  this.dots.eq(this.currentItem).trigger('click');
              }
          });
      }
  
      initRWD() {
          this.desktopViewport = window.matchMedia('(min-width: 841px)');
          this.tabletViewport = window.matchMedia('(min-width: 561px) and (max-width: 840px)');
          this.mobileViewport = window.matchMedia('(max-width: 560px)');
          if (this.desktopViewport.matches) this.updateViewports('desktop');
          if (this.tabletViewport.matches) this.updateViewports('tablet');
          if (this.mobileViewport.matches) this.updateViewports('mobile');
          this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
          this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
          this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
  
          if (this.desktopViewport.matches) {
              this.itemsPerPage = 3;
          } else if (this.tabletViewport.matches) {
              this.itemsPerPage = 2;
          } else if (this.mobileViewport.matches) {
              this.itemsPerPage = 1;
          }
  
          this.toggleDotsVisibility();
  
          this.desktopViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(3);
              }
          });
  
          this.tabletViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(2);
              }
          });
  
          this.mobileViewport.addListener(mq => {
              if (mq.matches) {
                  this.setItemsPerPage(1);
              }
          });
      }
  
      updateViewports(type) {
          if (this.currentViewport !== type) {
              this.currentItem = 0;
              this.list.css('margin-left', "0%");
              this.currentViewport = type;
              this.prevBtn.addClass('is-hidden');
              this.nextBtn.removeClass('is-hidden');
          }
      }
  
      setItemsPerPage(numberOfItems) {
          this.currentItem = 0;
          this.itemsPerPage = numberOfItems;
          this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
          this.toggleDotsVisibility();
      }
  
      toggleDotsVisibility() {
          let visibleDots = (this.dots.length - this.itemsPerPage) + 1;
  
          for (let i = 0; i < this.dots.length; i++) {
              let visibilityState = i < visibleDots ? 'block' : 'none';
              this.dots.eq(i).css('display', visibilityState);
          }
  
          if (this.itemsCount - this.itemsPerPage <= 0) {
              this.dotsList.css('display', 'none');
          } else {
              this.dotsList.css('display', 'flex');
          }
      }
  }
  
  /**
   * Category Trips Filters script
   */
  class Orion_CategoryTripsFilters {
    constructor() {
      this.initState();
    }
  
    initState() {
      this.categoryTrips = $(".category-trips");
      this.categoryForm = $(".category-form");
      this.categoryFormSelect = this.categoryForm.find("select");
      this.resetFilters = this.categoryTrips.find(".reset-filters");
      this.filterCategoryClear = this.categoryTrips.find(
        ".filter-category .clear"
      );
      this.filterBatchClear = this.categoryTrips.find(".filter-batch .clear");
      this.filterDirectionClear = this.categoryTrips.find(
        ".filter-direction .clear"
      );
      this.filterAgeClear = this.categoryTrips.find(".filter-age .clear");
  
      if (this.categoryTrips.length) {
        this.categoryForm.find("select").on("change", () => {
          this.setTrips();
        });
  
        this.initEvents();
      }
    }
  
    setTrips() {
      let category_id = $('.category-form select[name="category_id"]').val();
      let batch_id = $('.category-form select[name="batch_id"]').val();
      let direction = $('.category-form select[name="direction"]').val();
      let age = $('.category-form select[name="age"]').val();
  
      $(".reset-filters").removeClass("hidden");
  
      if (category_id != "") {
        $(".filter-category .value").text(
          $('.category-form select[name="category_id"] option:selected').text()
        );
        $(".filter-category").removeClass("hidden");
      } else {
        $(".filter-category .value").text("");
        $(".filter-category").addClass("hidden");
      }
  
      if (batch_id != "") {
        $(".filter-batch .value").text(
          $('.category-form select[name="batch_id"] option:selected').text()
        );
        $(".filter-batch").removeClass("hidden");
      } else {
        $(".filter-batch .value").text("");
        $(".filter-batch").addClass("hidden");
      }
  
      if (age != "") {
        $(".filter-age .value").text(
          $('.category-form select[name="age"] option:selected').text() + " lat"
        );
        $(".filter-age").removeClass("hidden");
      } else {
        $(".filter-age .value").text("");
        $(".filter-age").addClass("hidden");
      }
  
      if (direction != "") {
        $(".filter-direction .value").text(
          $('.category-form select[name="direction"] option:selected').text()
        );
        $(".filter-direction").removeClass("hidden");
      } else {
        $(".filter-direction .value").text("");
        $(".filter-direction").addClass("hidden");
      }
  
      $(".trip-item").each((i, item) => {
        let show_trip = true;
  
        let trip_category_id = $(item).data("category");
        let trip_batch_id = $(item).data("batch");
        let trip_age_from = $(item).data("age-from");
        let trip_direction = $(item).data("direction");
        let trip_age_to = $(item).data("age-to");
  
        if (category_id != "" && category_id != trip_category_id) {
          show_trip = false;
        } else if (batch_id != "" && (!trip_batch_id || typeof trip_batch_id !== "string" || !trip_batch_id.split(",").includes(batch_id))) {
          show_trip = false;
        } else if (direction != "" && direction != trip_direction) {
          show_trip = false;
        } else if (age != "" && (age < trip_age_from || age > trip_age_to)) {
          show_trip = false;
        }
  
        if (show_trip) {
          $(item).addClass("active");
        } else {
          $(item).removeClass("active");
        }
      });
    }
  
    initEvents() {
      this.resetFilters.on("click", () => {
        this.categoryFormSelect.val("").change();
        this.categoryTrips.find(".filter").addClass("hidden");
        $(".reset-filters").addClass("hidden");
        return false;
      });
  
      this.filterCategoryClear.on("click", () => {
        $('.category-form select[name="category_id"]').val("").change();
        this.categoryTrips.find(".filter-category").addClass("hidden");
      });
  
      this.filterBatchClear.on("click", () => {
        $('.category-form select[name="batch_id"]').val("").change();
        this.categoryTrips.find(".filter-batch").addClass("hidden");
      });
  
      this.filterAgeClear.on("click", () => {
        $('.category-form select[name="age"]').val("").change();
        this.categoryTrips.find(".filter-age").addClass("hidden");
      });
  
      this.filterDirectionClear.on("click", () => {
        $('.category-form select[name="direction"]').val("").change();
        this.categoryTrips.find(".filter-direction").addClass("hidden");
      });
    }
  }
  
  /**
   * Contact form script
   */
  class Orion_ContactForm {
      constructor() {
          this.initState();
      }
  
      initState() {
          this.contactForm = $('.contact-form');
          this.submitContactForm = this.contactForm.find('button[type="submit"]');
  
          if (!this.contactForm.length) {
              return
          }
  
          this.initEvents();
      }
  
      initEvents() {
          let formHelper = new Orion_FormHelper(this.contactForm);
  
          this.submitContactForm.on('click', e => {
              e.preventDefault();
              let result = formHelper.formValidate();
  
              if (result) {
                  this.contactForm.addClass('is-loading');
  
                  setTimeout(() => {
                      let form = $('.contact-form');
                      form.find('.form-validation-error').addClass('is-hidden');
                      form.find('.form-validation-fail').addClass('is-hidden');
  
                      $.ajax({
                          type: 'POST',
                          url: form.attr('action'),
                          data: form.serialize()
                      }).done((data) => {
                          console.log(data.message)
                          let output = [];
                          let messageFields = Object.keys(data.message);
  
                          for (let i = 0; i < messageFields.length; i++) {
                              let field = messageFields[i];
                              if (data.message[field].length) {
                                  output.push(data.message[field][0]);
                              }
                          }
  
                          form.find('.form-validation-success').html(output);
                          form.find('.form-validation-success').removeClass('is-hidden');
                      }).fail((data) => {
                          if (data.responseJSON && data.responseJSON.message) {
                              let output = [];
                              let messageFields = Object.keys(data.message);
  
                              for (let i = 0; i < messageFields.length; i++) {
                                  let field = messageFields[i];
                                  if (data.message[field].length) {
                                      output.push(data.message[field][0]);
                                  }
                              }
  
                              form.find('.form-validation-error').html(output);
                          } else {
                              form.find('.form-validation-fail').removeClass('is-hidden');
                          }
                      }).always(() => {
                          this.contactForm.removeClass('is-loading');
                      });
                  }, 2000);
              }
          });
      }
  }
  class Orion_TeamSliderBigBox {
      constructor(wrapper) {
          this.wrapper = wrapper;
          this.initState();
          this.initEvents(wrapper);
      }
  
      initState() {
          this.state = {
              itemsPerRow: 3,
              lastOpenedItemIndex: -1
          };
      }
  
      initEvents() {
          this.initUI();
      }
  
      initUI() {
          this.UI = {
              items: this.wrapper.find('.team-slider-item'),
              bigBoxContents: this.wrapper.find('.team-slider-item .text-wrapper .about-item'),
              bigBoxTriggers: this.wrapper.find('.team-slider-item .js-open-team-desc'),
              bigBox: this.wrapper.find('.team-item-big-box'),
              bigBoxContent: this.wrapper.find('.team-item-big-box .team-item-big-box__content'),
              bigBoxClose: this.wrapper.find('.team-item-big-box .close')
          };
  
          this.UI.bigBoxClose.on('click', e => {
              e.preventDefault();
              this.closeBigBox();
          });
  
          this.UI.bigBoxTriggers.each((i, btn) => {
              $(btn).on('click', e => {
                  e.preventDefault();
                  this.openBigBox(parseInt($(btn).attr('data-index'), 10));
              });
          });
  
          this.UI.bigBox.slideUp(0);
      }
  
      closeBigBox() {
          this.UI.bigBox.slideUp(350, () => {
              this.UI.bigBoxContent.empty();
          });
      }
  
      openBigBox(index) {
          this.closeBigBox();
  
          setTimeout(() => {
              this.UI.bigBoxContent.html(this.UI.bigBoxContents.eq(index).html());
  
              setTimeout(() => {
                  this.UI.bigBox.slideDown(350);
              }, 0);
          }, 400);
      }
  }
  class Orion_TeamSliderSmallBigBox {
      constructor(wrapper) {
          this.wrapper = wrapper;
          this.initState();
          this.initEvents(wrapper);
      }
  
      initState() {
          this.state = {
              itemsPerRow: 3,
              lastOpenedItemIndex: -1
          };
      }
  
      initEvents() {
          this.initUI();
      }
  
      initUI() {
          this.UI = {
              items: this.wrapper.find('.team-slider-item'),
              bigBoxContents: this.wrapper.find('.team-slider-item .text-wrapper .about-item'),
              bigBoxTriggers: this.wrapper.find('.team-slider-item .js-open-team-desc'),
              bigBox: this.wrapper.find('.team-item-big-box'),
              bigBoxContent: this.wrapper.find('.team-item-big-box .team-item-big-box__content'),
              bigBoxClose: this.wrapper.find('.team-item-big-box .close')
          };
  
          this.UI.bigBoxClose.on('click', e => {
              e.preventDefault();
              this.closeBigBox();
          });
  
          this.UI.bigBoxTriggers.each((i, btn) => {
              $(btn).on('click', e => {
                  e.preventDefault();
                  this.openBigBox(parseInt($(btn).attr('data-index'), 10));
              });
          });
  
          this.UI.bigBox.slideUp(0);
      }
  
      closeBigBox() {
          this.UI.bigBox.slideUp(350, () => {
              this.UI.bigBoxContent.empty();
          });
      }
  
      openBigBox(index) {
          this.closeBigBox();
  
          setTimeout(() => {
              this.UI.bigBoxContent.html(this.UI.bigBoxContents.eq(index).html());
  
              setTimeout(() => {
                  this.UI.bigBox.slideDown(350);
              }, 0);
          }, 400);
      }
  }
  class Orion_TeamListBigBox {
      constructor(wrapper) {
        this.wrapper = wrapper;
        this.initState();
        this.initEvents(wrapper);
      }
    
      initState () {
        this.state = {
          itemsPerRow: 3,
          lastOpenedItemIndex: -1
        };
      }
    
      initEvents() {
        this.initUI();
        this.initRWD();
      }
    
      initUI () {       
        this.UI = {
          items: this.wrapper.find('.team-item'),
          bigBoxContents: this.wrapper.find('.team-item .text-wrapper .about-item'),
          bigBoxTriggers: this.wrapper.find('.team-item .js-open-team-desc'),
          bigBox: this.wrapper.find('.team-item-big-box'),
          bigBoxContent: this.wrapper.find('.team-item-big-box .team-item-big-box__content'),
          bigBoxClose: this.wrapper.find('.team-item-big-box .close')
        };
          
        this.UI.bigBoxClose.on('click', e => {
          e.preventDefault();
          this.closeBigBox();
        });
    
        this.UI.bigBoxTriggers.each((i, btn) => {
          $(btn).on('click', e => {
            e.preventDefault();
            this.openBigBox(parseInt($(btn).attr('data-index'), 10));
          });
        });
    
        this.UI.bigBox.slideUp(0);
      }
    
      initRWD () {
        this.fullViewport = window.matchMedia('(min-width: 1201px)');
        this.desktopViewport = window.matchMedia('(min-width: 1025px) and (max-width: 1200px)');
        this.bigTabletViewport = window.matchMedia('(min-width: 721px) and (max-width: 1024px)');
        this.tabletViewport = window.matchMedia('(min-width: 501px) and (max-width: 720px)');
        this.mobileViewport = window.matchMedia('(max-width: 500px)');
        if (this.fullViewport.matches) this.updateViewports('full');
        if (this.desktopViewport.matches) this.updateViewports('desktop');
        if (this.bigTabletViewport.matches) this.updateViewports('bigtablet');
        if (this.tabletViewport.matches) this.updateViewports('tablet');
        if (this.mobileViewport.matches) this.updateViewports('mobile');
        this.fullViewport.addListener(mq => mq.matches ? this.updateViewports('full') : false);
        this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
        this.bigTabletViewport.addListener(mq => mq.matches ? this.updateViewports('bigtablet') : false);
        this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
        this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
    
    
        if (this.fullViewport.matches) {
          this.state.itemsPerRow = 3;
        } else if (this.desktopViewport.matches) {
          this.state.itemsPerRow = 2;
        } else if (this.bigTabletViewport.matches) {
          this.state.itemsPerRow = 3;
        } else if (this.tabletViewport.matches) {
          this.state.itemsPerRow = 2;
        } else if (this.mobileViewport.matches) {
          this.state.itemsPerRow = 1;
        }
      }
    
      updateViewports (type) {
        if (this.currentViewport !== type) {
          this.currentViewport = type;
          this.state.lastOpenedItemIndex = -1;
          this.UI.bigBox.find('.team-item-big-box__content').empty();
          this.wrapper.prepend(this.UI.bigBox);
          this.UI.bigBox.slideUp(0);
    
          if (this.fullViewport.matches) {
            this.state.itemsPerRow = 3;
          } else if (this.desktopViewport.matches) {
              this.state.itemsPerRow = 2;
          } else if (this.bigTabletViewport.matches) {
            this.state.itemsPerRow = 3;
          } else if (this.tabletViewport.matches) {
              this.state.itemsPerRow = 2;
          } else if (this.mobileViewport.matches) {
            this.state.itemsPerRow = 1;
          }
        }
      }
    
      closeBigBox () {
        this.UI.bigBox.slideUp(350, () => {
          this.UI.bigBoxContent.empty();
        });
      }
    
      openBigBox (index) {
        let previousIndex = this.state.lastOpenedItemIndex;
        this.closeBigBox();
        this.state.lastOpenedItemIndex = index;
    
        setTimeout(() => {
          let previousRow = Math.floor(previousIndex / this.state.itemsPerRow);
          let currentRow = Math.floor(index / this.state.itemsPerRow);
    
          if (previousRow !== currentRow) {
            let placeIndex = ((currentRow + 1) * this.state.itemsPerRow) - 1;
    
            if (placeIndex > this.UI.items.length - 1) {
              placeIndex = this.UI.items.length - 1;
            }
    
            this.UI.bigBox.insertAfter(this.UI.items.eq(placeIndex));
          }
    
          this.UI.bigBoxContent.html(this.UI.bigBoxContents.eq(index).html());
          
          setTimeout(() => {
            this.UI.bigBox.slideDown(350);
          }, 0);
        }, 400);
      }
    }
  /**
   * Gallery slider script
   */
  class Orion_GalleryMediaSlider {
    constructor (wrapper) {
      this.sliderWrapper = wrapper;  
      this.initState();
      this.initEvents();
    }
  
    initState() {
      this.prevBtn = this.sliderWrapper.find('.prev');
      this.nextBtn = this.sliderWrapper.find('.next');
      this.list = this.sliderWrapper.find('.gallery-media-slider-list');
      this.items = this.list.find('.gallery-media-slider-item');
      this.currentItem = 0;
      this.animationInProgress = false;
    }
  
    initEvents() {
      if (this.sliderWrapper.length) {
        this.initUI();
      }
    }
  
    initUI () {        
      this.swipeEffect = new Hammer(this.sliderWrapper[0]);
  
      this.prevBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem--;
        this.animationInProgress = true;
  
        if (this.currentItem === 0) {
          this.prevBtn.addClass('is-hidden');
        }
  
        this.list.css('margin-left', (-100 * this.currentItem) + "%");
        this.nextBtn.removeClass('is-hidden');
  
        setTimeout(() => {
            this.animationInProgress = false;
        }, 250);
      });
  
      this.nextBtn.on('click', e => {
        e.preventDefault();
  
        if (this.animationInProgress) {
          return;
        }
  
        this.currentItem++;
        this.animationInProgress = true;
  
        if (this.currentItem === (this.items.length - 1)) {
          this.nextBtn.addClass('is-hidden');
        }
  
        if (this.currentItem >= this.items.length) {
          this.currentItem = (this.items.length - 1);
        }
  
        this.list.css('margin-left', (-100 * this.currentItem) + "%");
        this.prevBtn.removeClass('is-hidden');
  
        setTimeout(() => {
          this.animationInProgress = false;
        }, 250);
      });
  
      this.swipeEffect.on('swipe', ev => {
        if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
          if (this.currentItem < this.items.length - this.itemsPerPage) {
            this.currentItem++;
          } else {
            this.currentItem = 0;
          }
  
          this.next.eq(this.currentItem).trigger('click');
        }
  
        if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
          if (this.currentItem > 0) {
            this.currentItem--;
          } else {
            this.currentItem = this.items.length - this.itemsPerPage;
          }
  
          this.prev.eq(this.currentItem).trigger('click');
        }
      });
    }
  }
  

  new Orion_Cookies();
  new Orion_Menu();
  new Orion_HomeSlider();
  new Orion_TeamSlider();
  new Orion_Tabs();
  new Orion_TestimonialsSlider();
  new Orion_TextSlider();
  new Orion_UI();
  new Orion_CookieBanner();
  new Orion_GallerySlider();
  new Orion_CategoryTripsFilters();
  new Orion_ContactForm();

  let tabsTribsSlider = $('.tabcontent-list');
  let smallSlider = $('.slider-small');
  let teamSlider = $('.team-slider-wrapper');
  let teamList = $('.team-list');
  let teamSliderSmall = $('.slider-small');
  let galleryMediaSlider = $('.gallery-media-slider');

  for (let i = 0; i < galleryMediaSlider.length; i++) {
    new Orion_GalleryMediaSlider(galleryMediaSlider.eq(i));
  }

  for (let i = 0; i < tabsTribsSlider.length; i++) {
    new Orion_TabsTripsSlider(tabsTribsSlider.eq(i));
  }

  for (let i = 0; i < smallSlider.length; i++) {
    new Orion_smallSlider(smallSlider.eq(i));
  }

  for (let i = 0; i < teamSlider.length; i++) {
    new Orion_TeamSliderBigBox(teamSlider.eq(i));
  }

  for (let i = 0; i < teamList.length; i++) {
    new Orion_TeamListBigBox(teamList.eq(i));
  }

  for (let i = 0; i < teamSliderSmall.length; i++) {
    new Orion_TeamSliderSmallBigBox(teamSliderSmall.eq(i));
  }

  var lightbox = new PhotoSwipeLightbox({
    gallery: '.gallery-grid-wrapper',
    children: '.gallery-grid-image',
    spacing: 0.5,
    opacity: 0.5,
    pswpModule: PhotoSwipe
  });
  lightbox.init();

  var lightbox = new PhotoSwipeLightbox({
    gallery: '.gallery-slider-wrapper',
    children: 'a',
    spacing: 0.5,
    opacity: 0.5,
    pswpModule: PhotoSwipe
  });
  lightbox.init();
})(jQuery);

function addFileUpdateListener(input) {
  var label = input.nextElementSibling;
  var labelVal = label.innerHTML;

  input.addEventListener('change', function (e) {
    var fileName = '';
    if (this.files && this.files.length > 1)
      fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
    else
      fileName = e.target.value.split('\\').pop();

    if (fileName)
      label.querySelector('span').innerHTML = fileName;
    else
      label.innerHTML = labelVal;
  });
}

function addMarginForProgram() {
  let mediaQuery = window.matchMedia('(max-width: 840px)');

  if (mediaQuery.matches) {
    let programList = document.querySelectorAll('.program-list');
    if (programList.length > 0) {
      programList.forEach(list => {
        let blockList = list.querySelectorAll('.wp-block-media-text');

        if (blockList.length > 0) {
          blockList.forEach(element => {
            if (!element.classList.contains('full-width')) {
              let heading = element.querySelector('.wp-block-media-text__content h3');
              let headingHeight = heading.getBoundingClientRect().height + 36;

              let imageMargin = element.querySelector('.wp-block-media-text__media');
              imageMargin.style.marginTop = `${headingHeight}px`;

              window.addEventListener('resize', () => {
                headingHeight = heading.getBoundingClientRect().height + 36;
                imageMargin.style.marginTop = `${headingHeight}px`;
              });
            }
          });
        }

      });
    }
  }
}
addMarginForProgram()